import { deepDives, backstagePeople, rankList } from '@/mocks/gossip';

export default function Features() {
  return (
    <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-16 px-4 py-16 md:px-6">
      {/* 深度观察 */}
      <section id="deep" className="scroll-mt-24">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-500">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
              IN-DEPTH
            </p>
            <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-foreground-950">
              深度观察
            </h2>
          </div>
          <a href="#contact" className="hidden shrink-0 items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 sm:flex">
            讲述你的故事
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
          {deepDives.map((d) => (
            <a
              href="#contact"
              key={d.id}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative overflow-hidden">
                <img
                  src={d.image}
                  alt={d.title}
                  className="h-64 w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                />
                <span className="absolute left-3 top-3 rounded bg-background-950/70 px-2 py-1 text-xs text-background-50 backdrop-blur">
                  {d.category}
                </span>
                <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-white">
                  {d.stat.num}
                  <span className="font-normal text-white/85">{d.stat.label}</span>
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-900 group-hover:text-primary-600">
                  {d.title}
                </h3>
                <p className="mt-1 text-sm font-medium text-accent-600">{d.subtitle}</p>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">
                  {d.body}
                </p>
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* 幕后人物 + 热度榜单 */}
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.5fr_1fr]">
        <section id="people" className="scroll-mt-24">
          <p className="flex items-center gap-2 text-sm font-medium text-accent-600">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
            BEHIND THE SCENES
          </p>
          <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-foreground-950">
            幕后人物
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            那些把事做成的普通人，值得被看见。我们记录镜头外、报表外的坚持与选择。
          </p>

          <div className="mt-6 flex flex-col gap-5">
            {backstagePeople.map((p) => (
              <a
                href="#contact"
                key={p.id}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300"
              >
                <img
                  src={p.image}
                  alt={p.title}
                  className="h-20 w-20 shrink-0 rounded-md object-cover"
                />
                <div className="min-w-0 flex-1">
                  <p className="text-xs font-medium text-primary-500">{p.role}</p>
                  <h3 className="mt-1 line-clamp-1 font-heading text-base font-bold text-foreground-900 group-hover:text-primary-600">
                    {p.title}
                  </h3>
                  <p className="mt-1 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                    {p.desc}
                  </p>
                </div>
                <span className="hidden shrink-0 rounded bg-secondary-100 px-2 py-1 text-xs text-secondary-800 sm:inline">
                  {p.tagline}
                </span>
              </a>
            ))}
          </div>
        </section>

        <aside id="rank" className="scroll-mt-24 lg:pl-2">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex items-center justify-between">
              <h2 className="font-heading text-xl font-bold text-foreground-950">热度榜单</h2>
              <span className="flex items-center gap-1 text-xs text-accent-600">
                <i className="ri-trophy-line" />
                实时更新
              </span>
            </div>
            <ol className="mt-4 space-y-1">
              {rankList.map((r, i) => (
                <li key={r.id}>
                  <a
                    href="#contact"
                    className="group flex items-start gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
                  >
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                        i < 3
                          ? 'bg-primary-500 text-white'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      {i + 1}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 group-hover:text-primary-600">
                        {r.title}
                      </span>
                      <span className="mt-1 flex items-center gap-2 text-xs text-foreground-400">
                        <span>{r.reads} 阅读</span>
                        <span className="inline-flex items-center text-primary-500">
                          {r.trend === 'up' && <i className="ri-arrow-up-line" />}
                          {r.trend === 'flat' && <i className="ri-swap-line text-foreground-400" />}
                          {r.trend === 'down' && <i className="ri-arrow-down-line text-secondary-500" />}
                        </span>
                      </span>
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          </div>
        </aside>
      </div>
    </div>
  );
}